// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 524) return "css/styles." + __webpack_require__.h() + ".css";
	// return url for filenames based on template
	return "css/" + chunkId + ".styles." + __webpack_require__.h() + ".css";
};